import { Box }               from '@chakra-ui/react';
import { Center }            from '@chakra-ui/react';
import { Container }         from '@chakra-ui/react';
import { Grid }              from '@chakra-ui/react';
import { GridItem }          from '@chakra-ui/react';
import { Image }             from '@chakra-ui/react';
import { NavBar }            from '@/components/ui/nav-bar';
import React                 from 'react'
import SelectLanguage        from '../select-language/SelectLanguage';
import { SystemStyleObject } from '@chakra-ui/react';
import logo                  from '@/assets/images/logo-black.png';
import publicBackground      from '@/assets/images/public-background.png';

interface IPageContainerProps {
	type?: 'public' | 'private'
}

const PageContainer = (props: React.PropsWithChildren<IPageContainerProps>) => {
	const { children, type } = props;
	
	return (
		<Container
			maxW="100%"
			{...styles.container[type || 'private'].base}
			lg={styles.container[type || 'private'].lg}
		>
			{
				type === 'public' ?
				<Box
					width="100vw"
					height="100vh"
				>
					<Box hideFrom="lg">
						<NavBar visual="login" >
							<Center height="100%">
								<Image src={logo} paddingLeft="20px" paddingRight="20px" width={{ base: 280, lg: 200 }} />
							</Center>
						</NavBar>
					</Box>
					<Grid 
						bg="gray.50" 
						height={{ base: "calc(100% - 100px)", lg: "100%" }}
						templateColumns={{ 
							base: "1fr", 
							lg: "0.30fr 0.80fr" 
						}}
					>
						<GridItem 
							bg="beige"
							bgImage={`url(${publicBackground})`}
							bgSize={'100%'}
							backgroundPosition="center"
							bgRepeat="no-repeat"
							height={'100%'}
							paddingTop={5}
							paddingLeft={10}
							paddingRight={10}
							hideBelow="lg"
						>
							<Image src={logo} width={280} />
						</GridItem>

						<GridItem>
							<Box 
								padding="10px"
								display="flex"
								flexDirection="row-reverse"
								paddingTop={{ base: "10px", lg: "20px" }}
								paddingRight="2vw"
								height={{ base: "60px", lg: "70px" }}
								bg="white"
							>
								<SelectLanguage 
									borderColor='rgba(112, 112, 112, 0.6)'
									color='black'
								/>
							</Box>

							<Box
								height={{ base: "calc(100% - 60px)" ,lg: "calc(100% - 70px)" }}
								bg="white"
							>
								{children}
							</Box>
						</GridItem>
					</Grid>
				</Box>
				:
				children
			}
		</Container>
	)

}

export default PageContainer;

const styles: {
	[key: string]: {
		[key: string]: {
			[key: string]: SystemStyleObject
		}
	}
} = {
	container: {
		public: {
			base: {
				padding: 0,
				margin: 0,
			},
		},
		private: {
			base: {
				display: "flex",
				flexDirection: "column",
				gap: "20px",
				paddingTop: "15px",
				paddingRight: "15px",
				paddingBottom: "15px",
				paddingLeft: "15px",
			},
			lg: {
				display: "flex",
				flexDirection: "column",
				gap: "20px",
				paddingTop: "40px",
				paddingRight: "50px",
				paddingBottom: "30px",
				paddingLeft: "50px",
			}
		}
	}
};